const UIFormValidateFullName = (message = 'Informe seu nome completo') => input =>
  /^[\D]+\s([\D']\s?)+$/.test(input) ? undefined : message

export default UIFormValidateFullName
